import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  accordionDetailsInner: {
    width: '100%',
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
}));
